const emptyStorage = () => {
    localStorage.removeItem('role');
    localStorage.removeItem('role_timestamp');
    localStorage.removeItem('user');
    localStorage.removeItem('user_timestamp');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('isLoggedIn_timestamp');
    sessionStorage.removeItem('selectedRestaurant');
    sessionStorage.removeItem('React::DevTools::lastSelection');
};

export { emptyStorage };